export default function(Vue) {
  Vue.auth = {
    setToken(token) {
      localStorage.setItem('token', token);
      localStorage.setItem('expiredTime', Math.floor(Date.now() / 1000) + 3600 * 24);
    },
    getToken() {
      let token = localStorage.getItem('token');
      let expiry = localStorage.getItem('expiredTime');
      let actualTime = Math.floor(Date.now() / 1000);

      if (actualTime > expiry) {
        localStorage.removeItem('token');
        localStorage.removeItem('expiredTime');
        return null;
      }
      if (!token) {
        return null;
      }

      return token;
    },
    destroyToken() {
      localStorage.removeItem('token');
    },
    isAuthenticated() {
      return !!this.getToken();
    }
  };

  Object.defineProperties(Vue.prototype, {
    $auth: {
      get() {
        return Vue.auth;
      }
    }
  })
}


// WEBPACK FOOTER //
// ./src/packages/auth/Auth.js